import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';
import { Filtered } from './filtered.component';
import {
  FilteredActions,
  selectFilteredExperiences,
  selectFilteredTitle,
  selectIsFetching,
  selectIsListenerActive,
} from '../../modules/filtered';
import { selectCommonFilters } from '../../modules/filters';
import { AnalyticsActions } from '../../modules/analytics';
import { selectIsFetchingAllMarkets } from '../../modules/contentRegistry';

const mapStateToProps = createStructuredSelector({
  isFetching: selectIsFetching,
  isFetchingAllMarkets: selectIsFetchingAllMarkets,
  filters: selectCommonFilters,
  experiences: selectFilteredExperiences,
  isListenerActive: selectIsListenerActive,
  pageTitle: selectFilteredTitle,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      startListeningQueryUpdate: FilteredActions.startListeningQueryUpdate,
      stopListeningQueryUpdate: FilteredActions.stopListeningQueryUpdate,
      logFilteredViewedExperiences: AnalyticsActions.logFilteredViewedExperiences,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(Filtered);
